<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="preface">
<p class="Head"><span class="bold">Author’s Preface</span></p>
<p class="para">It may not be out of place to explain how this book came to find its way into print. It was written for my little daughter, in the form of letters at various times, and not intended for publication, but many friends after reading them insisted that they should be published. One said: “You must not wait until you are dead before these letters are given to the world.”</p>
<p class="para">As my desire is, by the grace of God, to live many years yet, I now present these letters to the reader, supplemented by others from old time friends who braved the perils and dangers of pioneer life; and as they are intended to be a part of the history of this great state, care has been taken to keep strictly to the truth.</p>
<p class="para">It is hoped that a line here and there will be appreciated by those who ride in palace cars as well as the old pioneers who came west in prairie schooners.</p>
<p class="Rightpara"><em class="italic">R<span class="smallcaps">OBERT</span> V<span class="smallcaps">AUGHN</span></em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_ThenandNowbook_preface.vue?25a55376